export default __webpack_public_path__ + "static/flag-no-b568f9c815bb10b4fc177adf7f879c25.svg";